import { render, staticRenderFns } from "./profileConnector.vue?vue&type=template&id=afd53900&"
import script from "./profileConnector.vue?vue&type=script&lang=js&"
export * from "./profileConnector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports